import * as React from "react";
import { Button } from "@fluentui/react-components";

import PrimaryButton from "./PrimaryButton";
import { logInUser } from "../../helpers/auth/auth";

type ButtonAppearance = "outline" | "transparent" | "subtle" | "secondary" | "primary";

export default function SignInButton({ appearance = "subtle" }: { appearance?: ButtonAppearance }) {
  const size = "medium";

  const signInClickHandler = () => {
    logInUser();
  };

  return appearance !== "primary" ? (
    <Button onClick={signInClickHandler} size={size} appearance={appearance}>
      Sign In
    </Button>
  ) : (
    <PrimaryButton onClick={signInClickHandler} size={size}>
      Sign In
    </PrimaryButton>
  );
}
